import React from 'react';
import { Connect, PropsFromRedux } from './SearchAdviceContainer';
import { Hyperlink } from '../../../components/Hyperlink';
import { SearchAdviceHighlight } from './SearchAdviceHighlight';
import { StateType } from '../../../state/state.types';
import styles from './search_advice.module.scss';

type Props = PropsFromRedux & {
  advice: NonNullable<StateType['results']['adviceAction']>;
};

type State = {
  selectedKeywords: Array<string>;
  recommendedKeywords: Array<string>;
};

export class RawSearchAdvice extends React.Component<Props, State> {
  componentDidMount() {
    const { reportAdviceShown } = this.props;
    reportAdviceShown();
  }

  clickAdvice = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const { onFollowAdvice, onAdviceClicked } = this.props;
    onAdviceClicked();
    if (!event.metaKey && !event.ctrlKey && event.nativeEvent.which !== 2) {
      event.preventDefault();
      onFollowAdvice();
    }
  };

  render() {
    const { advice, adviceUrl } = this.props;
    return (
      <div data-test-id="search-advice" className={styles.advice}>
        {advice.textBegin && (
          <span
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: advice.textBegin }}
          />
        )}
        {advice.queryFormattedHtml && (
          <Hyperlink
            data-test-id="hyperlink"
            href={adviceUrl}
            className={styles.link}
            onClick={this.clickAdvice}
          >
            <SearchAdviceHighlight>
              {advice.queryFormattedHtml}
            </SearchAdviceHighlight>
          </Hyperlink>
        )}
        {advice.textEnd && (
          <span
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: advice.textEnd }}
          />
        )}
      </div>
    );
  }
}
export const SearchAdvice = Connect(RawSearchAdvice);
